module.exports = __webpack_public_path__ + "img/erp-logos_0018_sage100.88b5cd24.jpg";